import React, { useCallback, useMemo } from 'react';

import { ModalWrapper } from '@/components/wrappers';

import EmployerReactivationModalForm from './EmployerReactivationModalForms/EmployerReactivationModalForm';
import { EmployerReactivationResume } from './EmployerReactivationResume/EmployerReactivationResume';
import { useEmployerReactivationStore } from './stores/useEmployerReactivation.store';
import { useEmployerReactivationModalStore } from './stores';
import { ReactivationSteps } from './types';

const EMPLOYER_CUSTOM_NAME = 'Employer';

export const EmployerReactivationModal = () => {
  const handleChangeVisibility = useEmployerReactivationModalStore((state) => state.handleChangeVisibility);
  const modalVisible = useEmployerReactivationModalStore((state) => state.modalVisible);
  const employerName = useEmployerReactivationModalStore((state) => state.employerName);
  const step = useEmployerReactivationModalStore((state) => state.step);
  const handleResetModal = useEmployerReactivationModalStore((state) => state.handleReset);
  const handleResetStore = useEmployerReactivationStore((state) => state.handleReset);

  const modalTitle = useMemo(() => {
    return `Reactivate ${employerName || EMPLOYER_CUSTOM_NAME}`;
  }, [employerName]);

  const showTitle = useMemo(() => step === ReactivationSteps.FORM, [step]);

  const handleSetVisible = useCallback(() => {
    handleChangeVisibility(false);
    handleResetModal();
    handleResetStore();
  }, [handleChangeVisibility, handleResetModal, handleResetStore]);

  return (
    <ModalWrapper
      testId="EmployerReactivationModal"
      visible={modalVisible}
      onSetVisible={handleSetVisible}
      title={showTitle ? modalTitle : undefined}
      titleBoxStyle={{
        paddingBottom: '8px',
        paddingInline: '12px',
        textAlign: 'center',
      }}
      isClosingByClickOutsideBlocked
    >
      {step === ReactivationSteps.FORM && (
        <EmployerReactivationModalForm onCancel={handleSetVisible} />
      )}
      {step === ReactivationSteps.RESUME && (
        <EmployerReactivationResume />
      )}
    </ModalWrapper>
  );
};
